<template>
  <footer class="bg-base-content text-base-100">
    <!-- Main Footer Content -->
    <div class="container mx-auto px-4 py-12">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <!-- Company Info -->
        <div class="space-y-4">
          <div class="flex items-center space-x-2">
            <img
              src="/logo.png"
              alt="Soleando Logo"
              class="h-12 w-auto invert"
            />
          </div>
          <p class="text-base-100/80 text-sm">
            Descubre la magia del desierto con nuestros viajes únicos y
            personalizados. Experiencias auténticas que te conectarán con la
            naturaleza y la cultura local.
          </p>
          <div class="flex space-x-3">
            <!-- Social Media Icons -->

            <a
              href="https://www.instagram.com/soleando_es/"
              class="text-base-100/60 hover:text-base-100 transition-colors"
            >
              <Icon name="mdi:instagram" class="w-5 h-5" />
            </a>
            <a
              href="https://www.tiktok.com/@soleando_es"
              class="text-base-100/60 hover:text-base-100 transition-colors"
            >
              <Icon name="ic:baseline-tiktok" class="w-5 h-5" />
            </a>
          </div>
        </div>

        <!-- Quick Links -->
        <div class="space-y-4">
          <h3 class="text-lg font-semibold">Enlaces Rápidos</h3>
          <ul class="space-y-2">
            <li>
              <NuxtLink
                to="/"
                class="text-base-100/80 hover:text-base-100 transition-colors text-sm"
              >
                Inicio
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                to="/trips"
                class="text-base-100/80 hover:text-base-100 transition-colors text-sm"
              >
                Viajes
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                to="/blog"
                class="text-base-100/80 hover:text-base-100 transition-colors text-sm"
              >
                Blog
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                to="/about"
                class="text-base-100/80 hover:text-base-100 transition-colors text-sm"
              >
                Sobre Nosotros
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                to="/contact"
                class="text-base-100/80 hover:text-base-100 transition-colors text-sm"
              >
                Contacto
              </NuxtLink>
            </li>
          </ul>
        </div>

        <!-- Contact Info -->
        <div class="space-y-4">
          <h3 class="text-lg font-semibold">Contacto</h3>
          <div class="space-y-3">
            <div class="flex items-start space-x-3">
              <Icon
                name="heroicons:map-pin"
                class="w-5 h-5 mt-0.5 text-base-100/60"
              />
              <div class="text-sm text-base-100/80">
                <p>Calle Arturo Soria, 333</p>
                <p>28033 Madrid, España</p>
              </div>
            </div>
            <div class="flex items-center space-x-3">
              <Icon
                name="heroicons:envelope"
                class="w-5 h-5 text-base-100/60"
              />
              <a
                href="mailto:info@soleando.eu"
                class="text-sm text-base-100/80 hover:text-base-100 transition-colors"
              >
                info@soleando.eu
              </a>
            </div>
            <div class="flex items-center space-x-3">
              <Icon name="heroicons:phone" class="w-5 h-5 text-base-100/60" />
              <a
                href="tel:+34608762962"
                class="text-sm text-base-100/80 hover:text-base-100 transition-colors"
              >
                (+34) 608 76 29 62
              </a>
            </div>
            <div class="flex items-center space-x-3">
              <Icon name="heroicons:phone" class="w-5 h-5 text-base-100/60" />
              <a
                href="tel:+34620501761"
                class="text-sm text-base-100/80 hover:text-base-100 transition-colors"
              >
                (+34) 620 50 17 61
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Legal Links -->
    <div class="border-t border-base-100/20">
      <div class="container mx-auto px-4 py-6">
        <div
          class="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0"
        >
          <div class="flex flex-wrap justify-center lg:justify-start space-x-6">
            <NuxtLink
              to="/privacy"
              class="text-sm text-base-100/80 hover:text-base-100 transition-colors"
            >
              Política de Privacidad y Protección de Datos
            </NuxtLink>
            <NuxtLink
              to="/terms"
              class="text-sm text-base-100/80 hover:text-base-100 transition-colors"
            >
              Términos y Condiciones
            </NuxtLink>
            <NuxtLink
              to="/legal"
              class="text-sm text-base-100/80 hover:text-base-100 transition-colors"
            >
              Aviso Legal
            </NuxtLink>
            <NuxtLink
              to="/cookies"
              class="text-sm text-base-100/80 hover:text-base-100 transition-colors"
            >
              Política de Cookies
            </NuxtLink>
            <NuxtLink
              to="/accessibility"
              class="text-sm text-base-100/80 hover:text-base-100 transition-colors"
            >
              Declaración de Accesibilidad
            </NuxtLink>
            <NuxtLink
              to="/faq"
              class="text-sm text-base-100/80 hover:text-base-100 transition-colors"
            >
              F.A.Q.
            </NuxtLink>
          </div>
          <div class="text-center lg:text-right">
            <p class="text-sm text-base-100/80 mb-1">
              Desertando Club de Aventuras, S.L.
            </p>
            <p class="text-sm text-base-100/80 mb-1">
              C.I.F.: B87565966 | C.I.C.M.A.: 3627
            </p>
            <p class="text-sm text-base-100/80">
              © 2025 Soleando. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- EU and Ministry Logos -->
    <div class="border-t border-base-100/20">
      <div class="container mx-auto px-4 py-8">
        <div class="text-center mb-4">
          <p class="text-sm text-base-100/80 mb-2">
            Proyecto financiado por la Unión Europea y el Ministerio de
            Industria, Comercio y Turismo
          </p>
        </div>
        <div
          class="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-8"
        >
          <img
            src="/ministerio.png"
            alt="Logo del Ministerio de Industria, Comercio y Turismo"
            class="h-16 border-4 border-white"
          />
          <img
            src="/PRTR.png"
            alt="Plan de Recuperación, Transformación y Resiliencia"
            class="h-16 border-8 border-white"
          />
          <img src="/UE.png" alt="Logo Unión Europea" class="h-16" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup></script>

<style scoped></style>
